/* NISSE PDP — Turkish tax/shipping localization */
(function(){
  const isTR=()=>((document.documentElement.lang||'').toLowerCase().startsWith('tr')||!location.pathname.startsWith('/en'));
  function fix(root=document){
    if(!isTR()) return;
    root.querySelectorAll('.product__tax, .product__tax *').forEach(el=>{
      if(el.children.length) return;
      const t=(el.textContent||'').trim();
      if(/tax included/i.test(t)) el.textContent=t.replace(/tax included\.?/i,'Vergiler dahildir.');
      if(/shipping calculated at checkout/i.test(t)) el.textContent=t.replace(/shipping calculated at checkout\.?/i,'Kargo ücreti ödeme adımında hesaplanır.');
      if(/kargo calculated at checkout/i.test(t)) el.textContent=t.replace(/kargo calculated at checkout\.?/i,'Kargo ücreti ödeme adımında hesaplanır.');
    });
    root.querySelectorAll('.product__tax').forEach(el=>{
      const html=el.innerHTML;
      el.innerHTML=html
        .replace(/Tax included\.?/gi,'Vergiler dahildir.')
        .replace(/Shipping calculated at checkout\.?/gi,'Kargo ücreti ödeme adımında hesaplanır.')
        .replace(/Kargo calculated at checkout\.?/gi,'Kargo ücreti ödeme adımında hesaplanır.');
    });
  }
  function init(){fix();new MutationObserver(ms=>ms.forEach(m=>m.addedNodes.forEach(n=>{if(n.nodeType===1)fix(n)}))).observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',()=>fix());
})();